import isURL from 'validator/lib/isURL';

let validateUrl = (url) => {
    return isURL(url);
  }

export { validateUrl }